/**
 * Default Firestore query limits for frontend scaling (Phase 2).
 * Use these so list queries stay bounded and align across pages/hooks.
 */

/** Default page size for list queries (e.g. notifications, POs, partner requests). */
export const DEFAULT_LIST_LIMIT = 100;

/** Single-doc or small lookup (e.g. by poNumber, by id). */
export const LOOKUP_LIMIT = 1;

/** Small bounded batch (e.g. verify-load by poNumber + carrierId). */
export const SMALL_BATCH_LIMIT = 10;
